import React from "react";
import "./index.scss";

function ArticleBlog({ objectVal }) {
  const hasImage =
    objectVal?.mega_view_image && objectVal.mega_view_image !== "NULL";

  return (
    <div className="abh">
      {hasImage && (
        <div className="abh__bg-wrapper">
          <img
            className="abh__bg-img"
            src={objectVal.mega_view_image}
            alt=""
            aria-hidden="true"
          />
          <div className="abh__bg-overlay" />
        </div>
      )}
      <div className={`abh__inner${!hasImage ? " abh__inner--no-img" : ""}`}>
        <div className="abh__content body-container">
          {objectVal?.type && (
            <span className="abh__badge">{objectVal.type}</span>
          )}
          <h1 className={`abh__title${!hasImage ? " abh__title--dark" : ""}`}>
            {objectVal?.title}
          </h1>
          {objectVal?.author_name && (
            <div className="abh__meta">
              {objectVal?.author_image && (
                <img
                  className="abh__avatar"
                  src={objectVal.author_image}
                  alt={objectVal.author_name}
                />
              )}
              <div className="abh__meta-info">
                <span className="abh__meta-name">{objectVal.author_name}</span>
                {objectVal?.published_date && (
                  <span className="abh__meta-date">
                    {objectVal.published_date}
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ArticleBlog;
